export const paths = {
  login: '/login',
  home: '/home',

  page403: '/403',
  page404: '/404',
  page500: '/500',
  maintenance: '/maintenance',

  auth: {
    jwt: {
      login: '/login',
    },
  },

  app: {
    dashboard: '/dashboard',
    employees: '/employees',
    specialties: '/specialties',
    questions: '/questions',
    instructions: '/instructions',
    results: {
      root: '/results',
      detail: (id: number | string) => `/results/${id}`,
    },
    activityReport: '/activity-report',
    medical: {
      root: '/medical',
      create: (employeeId: number | string) => `/medical/new/${employeeId}`,
      detail: (id: number | string) => `/medical/${id}`,
      edit: (id: number | string) => `/medical/${id}/edit`,
    },
    locomotives: {
      root: '/locomotives',
      new: '/locomotives/new',
      edit: (id: number | string) => `/locomotives/${id}/edit`,
      detail: (id: number | string) => `/locomotives/${id}`,
    },
    wheelMeasurements: {
      root: '/wheel-measurements',
      new: '/wheel-measurements/new',
      edit: (id: number | string) => `/wheel-measurements/${id}/edit`,
    },
    testing: {
      root: '/testing',
      questions: (specialistId: number | string, module: string) =>
        `/testing/tests/${specialistId}/${module}`,
    },
    myResults: {
      detail: (id: number | string) => `/my-results/${id}`,
    },
  },
};
